const prices = [10.99, 15.99, 20.99, 29.99];

export default prices;